<!-- IS Header -->
<ui-external-header
  currentSiteName="Developer Cloud"
  [adminRouterLink]="auth.perm('ap-access') ? '/admin' : ''"
></ui-external-header>

<!-- Header -->
<ui-header
  #header
  logo="/img/logo.svg"
  [items]="menuItems()"
  [showMobileMenu]="true"
  [isLogged]="auth.isLogged"
  [userName]="auth.user.name || ''"
  [userAvatar]="auth.isImpersonating() ? 'img/icons/icon-warning.svg' : (auth.user.avatar?.url || '')"
  [notifications]="notifications"
  [notificationsButton]="auth.isLogged"
  [notificationCount]="auth.user.notifications || 0"
  (onLogin)="onLogin()"
  (onRegister)="onRegister()"
></ui-header>

<!-- [notificationResolver]="resolveNotifications" -->

@if (auth.user.waitlist) {
  <div class="msg-wait-list">
    <div class="ui-icon-unsaved"></div>You're in Demo Mode! Explore freely, but editing, saving, and deleting are disabled. We'll notify you as soon as full access is unlocked.
  </div>
}

@if (auth.isImpersonating()) {
  <div class="impersonation-frame"></div>
}

<div class="content">
  <!--ui-view-transition="content"
    transitionRules="exactRoutes"
    [transitionRoutes]="animatedRoutes"-->
  <router-outlet/>
</div>

<!-- Footer -->
@if (isFooter()) {
  <cld-footer></cld-footer>
}
